"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'List Data Records',
    description: 'List all records from a data collection with an optional filter',
});
//# sourceMappingURL=list-data-records.js.map